import { fetcher } from '../utils'
import { ComponentTagVO } from '@repo/types'

export default async (filter?: string): Promise<ComponentTagVO[]> => {
  const param = filter ? `?filter=${filter}` : ''
  return fetcher(`/api/tag/list${param}`, 'GET', undefined)
}
